export default __webpack_public_path__ + "static/media/organization_name_pink.5832ca9e.png";